import { useState } from 'react'

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui'
import {
  AddCaseFactButton,
  CaseFactList,
} from '@/modules/projects/components/caseFacts'
import { useFetchCaseFacts } from '@/modules/projects/hooks'
import { useDialogActions, useDialogIsOpen } from '@/stores/dialog'

const dialogId = 'case-facts'

interface CaseFactsDialogProps {
  slug: string
}

export const CaseFactsDialog = ({ slug }: CaseFactsDialogProps) => {
  useFetchCaseFacts(slug)
  const open = useDialogIsOpen(dialogId)
  const { closeDialog } = useDialogActions()
  const [isAdding, setIsAdding] = useState(false)

  const close = () => {
    setIsAdding(false)
    closeDialog()
  }

  return (
    <Dialog open={open} onOpenChange={(next) => !next && close()}>
      <DialogContent className="max-h-[85vh] max-w-2xl overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Case facts</DialogTitle>
          <DialogDescription>
            The assistant reads these in every chat and report and treats them
            as true.
          </DialogDescription>
        </DialogHeader>
        <div>
          <AddCaseFactButton
            isAdding={isAdding}
            onClick={() => setIsAdding(true)}
          />
        </div>
        <CaseFactList
          slug={slug}
          isAdding={isAdding}
          onAddingDone={() => setIsAdding(false)}
        />
      </DialogContent>
    </Dialog>
  )
}

CaseFactsDialog.id = dialogId
